import Vue from "vue"
import { Loading, Message } from "element-ui"
import { Base64 } from "js-base64"
import VueClipBoard from "vue-clipboard2"
import { translate } from "@/plugins/i18n"
import * as utils from "@/utils/utils"
import * as $filter from "@/utils/filter"
import messageBox from "@/library/messageBox/index"
import errorHandler from "@/plugins/error-handler"
import deliveryMethod from "@/components/drawer/deliveryMethodFun/index"

Vue.prototype.$translate = translate
Vue.prototype.$utils = utils
Vue.prototype.$filter = $filter
Vue.prototype.$message = Message // 直接用Vue.use(Message)会自动触发
Vue.prototype.$base64 = Base64
Object.keys($filter).forEach(k => Vue.filter(k, $filter[k]))

Vue.config.errorHandler = errorHandler

if (!Vue.__use_vue_comp__) {
  Vue.__use_vue_comp__ = true
  Vue.use(messageBox)
  Vue.use(Loading)
  Vue.use(deliveryMethod)
  Vue.use(VueClipBoard)
}

export default function (context, inject) {
  inject("utils", utils)
}
